export var ShimmerIconSizeTokens;
(function (ShimmerIconSizeTokens) {
    ShimmerIconSizeTokens["XXS"] = "XXS";
    ShimmerIconSizeTokens["XS"] = "XS";
    ShimmerIconSizeTokens["SM"] = "SM";
    ShimmerIconSizeTokens["MD"] = "MD";
    ShimmerIconSizeTokens["LG"] = "LG";
    ShimmerIconSizeTokens["XL"] = "XL";
    ShimmerIconSizeTokens["XXL"] = "XXL";
    ShimmerIconSizeTokens["XXXL"] = "XXXL";
    ShimmerIconSizeTokens["XXXXL"] = "XXXXL";
    ShimmerIconSizeTokens["XXXXXL"] = "XXXXXL";
    ShimmerIconSizeTokens["FULL"] = "FULL";
})(ShimmerIconSizeTokens || (ShimmerIconSizeTokens = {}));
